import { Controller } from '@hotwired/stimulus';

const PLURAL_SUFFIXES = { one: 'plik', few: 'pliki', many: 'plików', other: 'plików' };
const PLURAL_RULES = new Intl.PluralRules('pl');

export default class extends Controller {
  static targets = ['checkbox', 'select', 'hint', 'count', 'suffix'];

  get checkedBoxes() {
    return this.checkboxTargets.filter(cb => cb.checked);
  }

  update() {
    const { checkedBoxes } = this;
    const count = checkedBoxes.length;
    const selected = !!checkedBoxes.length;

    this.countTarget.textContent = count;
    this.suffixTarget.textContent = PLURAL_SUFFIXES[PLURAL_RULES.select(count)];
    this.selectTarget.classList.toggle('hidden', !selected);
    this.hintTarget.classList.toggle('hidden', selected);
  }

  download() {
    const { checkedBoxes } = this;
    const form = document.createElement('form');
    form.method = 'post';
    form.action = this.selectTarget.dataset.mergeUrl;

    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content;
    if (csrfToken) {
      const csrfInput = document.createElement('input');
      csrfInput.type = 'hidden';
      csrfInput.name = 'authenticity_token';
      csrfInput.value = csrfToken;
      form.appendChild(csrfInput);
    }

    checkedBoxes.forEach(cb => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'internal_document_ids[]';
      input.value = cb.value;
      form.appendChild(input);
    });

    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);

    if (!this.selectTarget.hasAttribute('data-skip-download-tracking')) {
      checkedBoxes.forEach(cb => this.markAsDownloaded(cb.value));
    }
  }

  cancel() {
    this.checkboxTargets.forEach(cb => cb.checked = false);
    this.update();
  }

  markAsDownloaded(id) {
    const row = document.getElementById(`internal_document_row_${id}`);
    if (!row || row.querySelector('.downloaded-icon')) return;

    const fileLink = row.querySelector('td a');
    if (!fileLink) return;

    const icon = document.createElement('span');
    icon.className = 'downloaded-icon';
    icon.setAttribute('data-tooltip', this.selectTarget.dataset.downloadedTooltip);
    icon.setAttribute('data-position', 'top center');
    icon.innerHTML = '<i class="check circle outline icon green-text"></i>';
    fileLink.after(' ', icon);
  }
}
